export enum USER_EXTENSIONS {
  POAP = "POAP",
  LINKS = "LINKS",
}

export enum LINKS {
  CUSTOM = "CUSTOM",
  DISCORD = "DISCORD",
  FACEBOOK = "FACEBOOK",
  INSTAGRAM = "INSTAGRAM",
  LINKEDIN = "LINKEDIN",
  MEDIUM = "MEDIUM",
  OPENSEA = "OPENSEA",
  TELEGRAM = "TELEGRAM",
  TIKTOK = "TIKTOK",
  TWITCH = "TWITCH",
  X = "X",
  WEBSITE = "WEBSITE",
  YOUTUBE = "YOUTUBE",
  WARPCAST = "WARPCAST",
}

export enum TEMPLATES {
  FACEBOOK = "https://facebook.com/{{username}}",
  INSTAGRAM = "https://instagram.com/{{username}}",
  LINKEDIN = "https://linkedin.com/in/{{username}}",
  MEDIUM = "https://medium.com/@{{username}}",
  OPENSEA = "https://opensea.io/{{username}}",
  TELEGRAM = "https://t.me/{{username}}",
  TIKTOK = "https://tiktok.com/@{{username}}",
  TWITCH = "https://twitch.tv/{{username}}",
  X = "https://x.com/{{username}}",
  YOUTUBE = "https://youtube.com/{{username}}",
  WARPCAST = "https://warpcast.com/{{username}}",
}
